import "./CustomizeBenefits.css";
import React from "react";
import ContentItem from "shared/components/cms/ContentItem";

export default () => (
    <div className="customize-benefits-wrapper">
        <div className="customize-benefits">
            <div className="customize-image-wrapper">
                <img className="customize-image" alt="Customize your benefits" src={require("../assets/redesign2020/products/customize.png")} />
            </div>
            <div className="customize-body">
                <img alt="chevron" className="chevron" src={require("../assets/redesign2020/chevron.svg")} />
                <h2 className="customize-header">
                    Customize your benefits, <span className="highlighted">maximize your impact</span>.
                </h2>
                <ContentItem tag="p" sharedKey="marketing2020/customizeBenefits" contentKey="customizeBenefitsBody1" className="customize-body-text" />
                <h3 className="customize-subheader">
                    Our exceptional service means <span className="highlighted">less stress</span> for you.
                </h3>
                <ContentItem tag="p" sharedKey="marketing2020/customizeBenefits" contentKey="customizeBenefitsBody2" className="customize-body-text" />
            </div>
        </div>
    </div>
);